import React, { Component } from 'react';
import { RepresentativePageText } from '../assets/lang/english';

import IMG_BannerRepresentative from '../assets/images/partners/more/pic_banner_representative.jpg';
import IMG_Content from '../assets/images/partners/more/pic_rep_2.jpg';
import BecomeAffiliateModal from '../components/BecomeAffiliateModal';
import ReactGA from 'react-ga';

class RepresentativePage extends Component {
	state = {
		modal: false
	}

	componentDidMount() {
		window.scrollTo(0, 0);
		ReactGA.pageview('/educators/representative');
	}

	close = () => {
		this.setState({
			modal: false
		})
	}

	render() {
		return (
			<main className="partners-more">
				{ this.state.modal && <BecomeAffiliateModal show={this.state.modal} onHide={this.close} type={3} />}
				<div className="partners-more__header">
					<h1 className="partners-more__header__h1">Educators</h1>
					<img src={IMG_BannerRepresentative} className="partners-more__header__image partners-more__header__image--bordered" />
					<p className="partners-more__header__paragraph">
						{RepresentativePageText[1]}
					</p>
				</div>
				<div className="partners-more__content">
					<img src={IMG_Content} alt="Individual Plan Image" className="partners-more__content__image" />
					<p className="partners-more__content__paragraph">
						{RepresentativePageText[2]}
					</p>
				</div>
		
				<button className="btn partners-more-button" onClick={() => this.setState({ modal: true })}>Sign up Now</button>
			</main>
		);
	}
}

export default RepresentativePage;